const MAX_CAUSE_DEPTH = 6;

/**
 * True when the value looks like an HTTP 401 (e.g. wretch's WretchError).
 * Walks Error.cause for wrapped failures. Used by
 * Sentry beforeSend to treat session expiry as expected.
 */
export function isUnauthorizedHttpError(error: unknown): boolean {
  let current: unknown = error;
  for (let i = 0; i < MAX_CAUSE_DEPTH && current != null; i += 1) {
    const status = (current as { status?: unknown }).status;
    if (status === 401) return true;
    const cause =
      current instanceof Error && 'cause' in current
        ? (current as Error & { cause?: unknown }).cause
        : undefined;
    current = cause;
  }
  return false;
}
